import React from 'react';
import { inject, observer } from 'mobx-react';
import {
  Table, Modal, Icon, Input,
} from 'antd';
import { toJS } from 'mobx';

const Search = Input.Search;
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'dev-apply-guys'
  }
  componentDidMount() {
    const { devStore: { getPerson } } = this.props;
    getPerson();
  }
  onCancel = () => {
    const {
      devStore: { setMobxState, getPerson },
    } = this.props;
    setMobxState({ guysVisible: false, guysCurrent: 1, guysSelectedRowKeys: [], guysSelectedRows: [], guysSearchName: '' });
    getPerson({ guysCurrent: 1 });
  }
  getColumns = () => {
    return [{
      title: '姓名',
      dataIndex: 'm_name',
    }, {
      title: '类型',
      dataIndex: 'm_role'
    }, {
      title: 'id',
      dataIndex: 'm_id',
    }];
  }
  onChange = (page) => {
    const { devStore: { setMobxState, getPerson } } = this.props;
    setMobxState({ guysCurrent: page });
    getPerson({ guysCurrent: page });
  }
  onSearch = (e) => {
    const { devStore: { setMobxState, getPerson } } = this.props;
    setMobxState({ guysCurrent: 1, guysSearchName: e.target.value });
    getPerson({ guysCurrent: 1, name: e.target.value });
  }
  onOk = () => {
    const { devStore: { setMobxState, guysSelectedRows, member } } = this.props;
    const res = toJS(member);
    toJS(guysSelectedRows).forEach(v => {
      if (!res.find(k => k.m_id === v.m_id)) res.push({
        ...v,
        m_softrole: '',
      });
    });
    setMobxState({ member: res });
    this.onCancel();
  }
  render() {
    const {
      prefixCls,
      devStore: { guysVisible, guysList, guysCount, guysCurrent, guysPageSize,
        guysLoading, setMobxState, guysSelectedRowKeys, guysSearchName },
    } = this.props;
    const title = (
      <div className={`${prefixCls}-header`}>
        <span className={`${prefixCls}-header-icon`}><Icon type="cluster" /></span>
        <span className={`${prefixCls}-header-title`}>添加参与者</span>
      </div>
    )
    return (
      <Modal
        title={title}
        className={`${prefixCls}`}
        visible={guysVisible}
        onCancel={this.onCancel}
        onOk={this.onOk}
        width={600}
      >
        <div className={`${prefixCls}-body`}>
          <div className={`${prefixCls}-body-search`}>
            <Search onPressEnter={this.onSearch} onChange={(e) => setMobxState({guysSearchName: e.target.value})} value={guysSearchName} />
          </div>
          <Table
            rowKey="m_id"
            loading={guysLoading}
            columns={this.getColumns()}
            dataSource={toJS(guysList)}
            pagination={{
              current: parseInt(guysCurrent, 10),
              total: parseInt(guysCount, 10),
              pageSize: parseInt(guysPageSize, 10),
              showQuickJumper: true,
              size: 'small',
              onChange: this.onChange,
            }}
            rowSelection={{
              selectedRowKeys: toJS(guysSelectedRowKeys),
              onChange: (selectedRowKeys, selectedRows) => {
                setMobxState({ guysSelectedRowKeys: selectedRowKeys, guysSelectedRows: selectedRows });
              },
            }}
          />
        </div>
      </Modal>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/devApply/Guys.js